import api from '../../services/service'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      config: {},
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  methods: {
    uploadLogo () {
      this.$store.state.isLoading = true
      var imagefile = document.querySelector('#file')
      if (imagefile.files.length > 0) {
        let formData = new FormData()
        formData.append('file', imagefile.files[0])
        this.$store.state.isLoading = true
        api.UploadFile(
          formData,
          this.header,
          result => {
            if (result.response === true) {
              this.config.logo_path = result.image_path
            }
            this.$store.state.isLoading = false
          },
          error => {
            this.$store.state.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      } else {
        alert('กรุณาแนบไฟล์ใบเสร็จ')
      }
    },
    saveConfig () {
      this.$store.state.isLoading = true
      api.UpdateConfig(
        this.config,
        this.header,
        result => {
          if (result.response === true) {
            Swal.fire('แก้ไขข้อมูล', result.message, 'success')
            this.getConfig()
          } else {
            this.getConfig()
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getConfig () {
      this.$store.state.isLoading = true
      api.getConfig(
        result => {
          if (result.response === true) {
            this.config = result.data
            this.$store.state.config = result.data
            sessionStorage.config = JSON.stringify(result.data)
          } else {
            this.getConfig()
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getConfig()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js